export function reportInputProductMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      reportInputProductId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateReportInputProductId(json) {
  return {
    data: {...json, id: json.objectId},
  };
}

export function fixCreateReportInputProductId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function fixGetManyReportInputProduct(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      reportInputProductId: resource.objectId,
    })),
  };
}

export function reportInputProductMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, reportInputProductId: json.result.objectId},
  };
}